function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#FCD669"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M11.53 1.3L3.29 18.2a.52.52 0 00.61.74l8.1-2.31V1a.5.5 0 00-.47.3z"
}), React.createElement("path", {
  fill: "#CE7C3A",
  d: "M20.71 18.2L12.47 1.3A.5.5 0 0012 1v15.63l8.1 2.31a.52.52 0 00.61-.74z"
}))));